import { FC, useMemo } from 'react';
import { Box, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

const TransactionVolumes: FC<{ volumes: Record<string, string | number>[] }> = ({ volumes }) => {
  if (!volumes || !Array.isArray(volumes) || volumes.length === 0) return null;

  const columns = useMemo(() => {
    return Object.keys(volumes[0]).map((key) => ({
      header: key,
      accessor: key,
    }));
  }, [volumes]);

  return (
    <Box backgroundColor='white' borderWidth='2px' borderRadius='15px' p={4} overflowX='auto'>
      <Table size='sm'>
        <Thead>
          <Tr>
            {columns.map((column) => (
              <Th key={column.accessor}>{column.header}</Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {volumes.map((row) => (
            <Tr key={row.duration}>
              {columns.map((column) => (
                <Td key={column.accessor}>{row?.[column?.accessor]}</Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default TransactionVolumes;
